import React from 'react';
import { BUCKET_COLORS } from '../lib/driveBucket';

export default function DriveBucketBadge({ bucket, onClick, active = false }) {
  if (!bucket) return null;
  const color = BUCKET_COLORS[bucket] || BUCKET_COLORS.unknown;
  const base = 'inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium';
  const style = active
    ? { backgroundColor: color, color: '#fff' }
    : { backgroundColor: `${color}22`, color, border: `1px solid ${color}55` };
  const Tag = onClick ? 'button' : 'span';
  return (
    <Tag
      type={onClick ? 'button' : undefined}
      onClick={onClick}
      className={`${base} ${onClick ? 'cursor-pointer hover:opacity-80' : ''}`}
      style={style}
    >
      <span className="w-2 h-2 rounded-full" style={{ backgroundColor: color }} />
      {bucket}
    </Tag>
  );
}
